<template>
  <section class="container-full-5">
    <div class="page-space-5"></div>

    <div>
      <div class="my-5" style="display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;">
        <h4 class="font-semibold mt-4" style="margin: 0;">
          Dashboard {{ collectiviteNom ? collectiviteNom : 'Collectivité' }}
        </h4>
        <router-link
          to="/front/collectivites/membres"
          class="btn"
          style="white-space: nowrap; color: var(--color-white) !important;"
        >
          <img src="/public/icons/icon-user.svg" class="btn-icon icon-white" alt="" />
          <span style="color: var(--color-white); white-space: nowrap;">Gérer les membres</span>
        </router-link>
      </div>
    </div>
    <div class="clear-both h-20"></div>

    <!-- Cartes de statistiques -->
    <div class="d-flex">
      <section class="flex-1">
        <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
          <div style="flex: 1;text-align: center;">
            <div class="container-full-2">
              <div class="s20"><h4 class="font-light">Total Membres</h4></div>
              <div class="clear-both"></div>
              <div class="text-4xl font-bold">{{ formatNumber(stats.totalMembres) }}</div>
            </div>
          </div>
        </div>
      </section>
      <section class="flex-1">
        <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
          <div style="flex: 1;text-align: center;">
            <div class="container-full-2">
              <div class="s20"><h4 class="font-light">Membres actifs</h4></div>
              <div class="clear-both"></div>
              <div class="text-4xl font-bold">{{ formatNumber(stats.membresActifs) }}</div>
            </div>
          </div>
        </div>
      </section>
      <section class="flex-1">
        <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
          <div style="flex: 1;text-align: center;">
            <div class="container-full-2">
              <div class="s20"><h4 class="font-light">Encours total</h4></div>
              <div class="clear-both"></div>
              <div class="text-4xl font-bold">{{ formatNumber(stats.encoursTotal) }}</div>
            </div>
          </div>
        </div>
      </section>
      <section class="flex-1">
        <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
          <div style="flex: 1;text-align: center;">
            <div class="container-full-2">
              <div class="s20"><h4 class="font-light">Retards paiement</h4></div>
              <div class="clear-both"></div>
              <div class="text-4xl font-bold">{{ stats.retardsPaiement }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="clear-both h-20"></div>

    <!-- Graphiques et tableaux -->
    <div class="d-flex" style="height: 400px">
      <section style="height: 100%;display: flex; flex: 1 1 60%">
        <div class="widget shadow-100 pb-2">
          <div>
            <div class="container-full-2">
              <div class="s20"><h4 class="font-semibold mt-8">Souscriptions par mois</h4></div>
              <div class="clear-both h-20"></div>
              <div class="chart-container">
                <div class="bar-chart-wrapper">
                  <div 
                    v-for="(value, index) in souscriptionsSeries.data" 
                    :key="index"
                    class="bar-chart-item"
                    :style="{ height: `${(value / maxSouscription) * 100}%` }"
                  >
                    <span class="bar-value">{{ value }}</span>
                  </div>
                </div>
                <div class="chart-labels">
                  <span v-for="(label, index) in souscriptionsSeries.categories" :key="index">{{ label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="flex-1" style="height: 100%;display: flex;">
        <div class="widget shadow-100 pb-2">
          <div>
            <div class="container-full-2">
              <div class="s20"><h4 class="font-semibold mt-8">Membres récents</h4></div>
              <div class="clear-both h-20"></div>
              <div class="clear-both"></div>
              <table class="table separator skin1">
                <thead>
                  <tr> 
                    <th>Nom &amp; Prénoms</th>
                    <th>
                      <img src="/public/icons/icon-filter-down.svg" class="size-xxs mt--1" alt="" /> Date inscription
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(membre, index) in membresRecents" :key="index">
                    <td>{{ membre.nom }} {{ membre.prenom }}</td>
                    <td>{{ membre.dateInscription }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="clear-both h-20"></div>

    <!-- Graphique remboursements et tableau retards -->
    <div class="d-flex" style="height: 400px">
      <section class="flex-1" style="height: 100%;display: flex;">
        <div class="widget shadow-100 pb-2">
          <div>
            <div class="container-full-2">
              <div class="s20"><h4 class="font-semibold mt-8">Courbe des remboursements (Prévu vs Payé)</h4></div>
              <div class="clear-both"></div>
              <div class="line-chart-container">
                <svg class="line-chart" viewBox="0 0 600 200" preserveAspectRatio="none">
                  <!-- Grille -->
                  <defs>
                    <linearGradient id="gradientPrevu" x1="0%" y1="0%" x2="0%" y2="100%">
                      <stop offset="0%" style="stop-color:#2563EB;stop-opacity:0.3" />
                      <stop offset="100%" style="stop-color:#2563EB;stop-opacity:0" />
                    </linearGradient>
                    <linearGradient id="gradientPaye" x1="0%" y1="0%" x2="0%" y2="100%">
                      <stop offset="0%" style="stop-color:#10B981;stop-opacity:0.3" />
                      <stop offset="100%" style="stop-color:#10B981;stop-opacity:0" />
                    </linearGradient>
                  </defs>
                  <!-- Zone prévu -->
                  <path 
                    :d="generateAreaPath(remboursementSeries.prevu, 200)" 
                    fill="url(#gradientPrevu)" 
                    stroke="#2563EB" 
                    stroke-width="2"
                    fill-opacity="0.3"
                  />
                  <!-- Zone payé -->
                  <path 
                    :d="generateAreaPath(remboursementSeries.paye, 200)" 
                    fill="url(#gradientPaye)" 
                    stroke="#10B981" 
                    stroke-width="2"
                    fill-opacity="0.3"
                  />
                  <!-- Ligne prévu -->
                  <path 
                    :d="generateLinePath(remboursementSeries.prevu, 200)" 
                    fill="none" 
                    stroke="#2563EB" 
                    stroke-width="2"
                  />
                  <!-- Ligne payé -->
                  <path 
                    :d="generateLinePath(remboursementSeries.paye, 200)" 
                    fill="none" 
                    stroke="#10B981" 
                    stroke-width="2"
                  />
                </svg>
                <div class="line-chart-labels">
                  <span v-for="(label, index) in remboursementSeries.categories" :key="index">{{ label }}</span>
                </div>
                <div class="line-chart-legend">
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #2563EB;"></span>
                    <span>Prévu</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #10B981;"></span>
                    <span>Payé</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="flex-1" style="height: 100%;display: flex;">
        <div class="widget shadow-100 pb-2">
          <div>
            <div class="container-full-2">
              <div class="s20"><h4 class="font-semibold mt-8">Membres avec retards de paiement</h4></div>
              <div class="clear-both"></div>
              <table class="table separator skin1">
                <thead>
                  <tr> 
                    <th>Nom &amp; Prénoms</th>
                    <th>Solde</th>
                    <th>
                      <img src="/public/icons/icon-filter-down.svg" class="size-xxs mt--1" alt="" /> Date Dernier Paiement
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="membresRetards.length === 0">
                    <td colspan="3" class="text-center text-grey-600">Aucun retard de paiement</td>
                  </tr>
                  <tr v-for="(membre, index) in membresRetards" :key="index">
                    <td>{{ membre.nom }}</td>
                    <td>{{ formatNumber(membre.solde) }}</td>
                    <td>{{ membre.dateDernierPaiement }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="clear-both h-20"></div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import membersService from '@/services/membersService'
import authService from '@/services/authService'

interface Stats {
  totalMembres: number
  membresActifs: number
  encoursTotal: number
  retardsPaiement: number
}

interface MembreRecent {
  nom: string
  prenom: string
  dateInscription: string
}

interface MembreRetard {
  nom: string
  solde: number
  dateDernierPaiement: string
}

const collectiviteId = ref<number | null>(null)
const collectiviteNom = ref<string>('')

const stats = ref<Stats>({
  totalMembres: 0,
  membresActifs: 0,
  encoursTotal: 0,
  retardsPaiement: 0
})

const souscriptionsSeries = ref({
  data: [230, 250, 280, 320, 310, 290, 340, 360, 400],
  categories: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aou', 'Sep']
})

const remboursementSeries = ref({
  prevu: [20000, 24000, 26000, 28000, 30000, 32000],
  paye: [18000, 20000, 25000, 26000, 28000, 31000],
  categories: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun']
})

const membresRecents = ref<MembreRecent[]>([])

const membresRetards = ref<MembreRetard[]>([])

const maxSouscription = computed(() => {
  return Math.max(...souscriptionsSeries.value.data)
})

function formatNumber(num: number): string {
  return new Intl.NumberFormat('fr-FR').format(num)
}

function generateLinePath(data: number[], height: number): string {
  const max = Math.max(...data)
  const width = 600
  const step = width / (data.length - 1)
  
  let path = `M 0 ${height - (data[0] / max) * height}`
  for (let i = 1; i < data.length; i++) {
    const x = i * step
    const y = height - (data[i] / max) * height
    path += ` L ${x} ${y}`
  }
  
  return path
}

function generateAreaPath(data: number[], height: number): string {
  const max = Math.max(...data)
  const width = 600
  const step = width / (data.length - 1)
  
  let path = `M 0 ${height}`
  path += ` L 0 ${height - (data[0] / max) * height}`
  
  for (let i = 1; i < data.length; i++) {
    const x = i * step
    const y = height - (data[i] / max) * height
    path += ` L ${x} ${y}`
  }
  
  path += ` L ${width} ${height} Z`
  
  return path
}

async function loadStats() {
  try {
    // Récupérer l'utilisateur connecté
    const currentUser = authService.getCurrentUser()
    if (!currentUser) {
      console.error('Utilisateur non connecté')
      return
    }

    // Récupérer l'ID de la collectivité depuis les données utilisateur
    const userCollectiviteId = currentUser.collectivite_id || currentUser.collectivite?.id || null
    
    if (!userCollectiviteId) {
      console.warn('Aucune collectivité associée à l\'utilisateur')
      return
    }

    collectiviteId.value = userCollectiviteId
    collectiviteNom.value = currentUser.collectivite?.nom || 'Ma Collectivité'

    // Charger les membres de cette collectivité uniquement
    const membersData = await membersService.listMembers({ 
      pageNumber: 1,
      collectivite_id: String(userCollectiviteId)
    })
    
    if (membersData.total !== undefined) {
      stats.value.totalMembres = membersData.total
    }

    // Compter les membres actifs
    if (membersData.data) {
      stats.value.membresActifs = membersData.data.filter((m: any) => m.actif === 1 && !m.deleted_at).length
      
      // Récupérer les membres récents (5 derniers)
      membresRecents.value = membersData.data
        .filter((m: any) => !m.deleted_at)
        .sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
        .slice(0, 5)
        .map((m: any) => ({
          nom: m.nom,
          prenom: m.prenom,
          dateInscription: formatDate(m.created_at)
        }))
    }

    // TODO: Charger les autres statistiques depuis l'API quand les endpoints seront disponibles
    // Pour l'instant, on utilise des valeurs par défaut
    stats.value.encoursTotal = 183400000
    stats.value.retardsPaiement = 0

    // TODO: Charger les membres avec retards de paiement depuis l'API
    // membresRetards.value = await loadMembresRetards(userCollectiviteId)
    
  } catch (error) {
    console.error('Erreur lors du chargement des statistiques:', error)
  }
}

function formatDate(dateString?: string): string {
  if (!dateString) return '—'
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

onMounted(() => {
  loadStats()
})
</script>

<style scoped>
.chart-container {
  padding: 20px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bar-chart-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  height: 200px;
  gap: 10px;
  padding: 10px 0;
}

.bar-chart-item {
  flex: 1;
  background: linear-gradient(180deg, #3B82F6 0%, #2563EB 100%);
  border-radius: 5px 5px 0 0;
  position: relative;
  min-width: 30px;
  transition: all 0.3s ease;
}

.bar-chart-item:hover {
  opacity: 0.8;
  transform: scaleY(1.05);
}

.bar-value {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
}

.chart-labels {
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  color: #6b7280;
  margin-top: 10px;
}

.line-chart-container {
  padding: 20px;
  height: 300px;
  position: relative;
}

.line-chart {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
}

.line-chart-labels {
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  color: #6b7280;
  margin-top: 10px;
}

.line-chart-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6b7280;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.font-bold {
  font-weight: 700;
}

.font-light {
  font-weight: 300;
}

.font-semibold {
  font-weight: 600;
}

.shadow-100 {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.d-flex {
  display: flex;
  gap: 20px;
}

.flex-1 {
  flex: 1;
}

.page-space-5 {
  height: 20px;
}

.h-20 {
  height: 20px;
}

.clear-both {
  clear: both;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-8 {
  margin-top: 2rem;
}

.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}
</style>
